var map = {
	"./about/page.tsx": 3201,
	"./admin/about/page.tsx": 6767,
	"./admin/certificates/[id]/page.tsx": 4920,
	"./admin/certificates/page.tsx": 1345,
	"./admin/index/page.tsx": 4237,
	"./admin/login/page.tsx": 7236,
	"./admin/posts/[id]/page.tsx": 5406,
	"./admin/posts/page.tsx": 5884,
	"./admin/projects/[id]/page.tsx": 2581,
	"./admin/projects/page.tsx": 8798,
	"./admin/skills/page.tsx": 7309,
	"./blog/[slug]/page.tsx": 4958,
	"./blog/page.tsx": 4475,
	"./error/page.tsx": 9138,
	"./home/page.tsx": 8356,
	"./my-skills/page.tsx": 6392,
	"./projects/page.tsx": 5685
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1139;